export default {"src":"/_next/static/media/volumeIcon.b94f74ae.svg","height":34,"width":41};